import { render, staticRenderFns } from "./sold.vue?vue&type=template&id=ca8040d4&scoped=true&"
import script from "./sold.vue?vue&type=script&lang=js&"
export * from "./sold.vue?vue&type=script&lang=js&"
import style0 from "./sold.vue?vue&type=style&index=0&id=ca8040d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8040d4",
  null
  
)

export default component.exports